import { SmartTableColumn, WithNAFallback } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SharedTable } from '../../../components/shared-table/SharedTable';
import * as S from './KpisTable.styles';

export interface KpiData {
  title: string;
  description: string;
  value: string;
}

export interface KpisTableProps {
  kpisData: KpiData[];
}

export const KpisTable = ({ kpisData }: KpisTableProps) => {
  const { t } = useTranslation(['earnings']);

  const tableData = (kpisData || []).map((item, index) => ({
    ...item,
    key: `kpi-${index}`,
  }));

  const tableColumns: SmartTableColumn<KpiData>[] = [
    {
      key: 'title',
      label: t('earningsInsight.drawer.earningsPreview.tables.kpi'),
      render: (value: string) =>
        value ? <S.StyledTitleCell>{value}</S.StyledTitleCell> : '',
    },
    {
      key: 'description',
      label: t('earningsInsight.drawer.earningsPreview.tables.significance'),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<S.StyledDescriptionCell>{value}</S.StyledDescriptionCell>}
        />
      ),
    },
    {
      key: 'value',
      label: t(
        'earningsInsight.drawer.earningsPreview.tables.consensusExpectations'
      ),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<S.NumberCell>{value}</S.NumberCell>}
        />
      ),
    },
  ];

  return (
    <>
      <S.Title>
        {t('earnings:earningsInsight.drawer.earningsPreview.items.kpis')}
      </S.Title>
      <SharedTable
        tableData={tableData}
        tableColumns={tableColumns}
        noCellPadding
      />
    </>
  );
};
